import React from 'react';

const PhoneNumberFormatText = () => {
  return <small>The phone number should be in international format: country code then phone number.</small>;
};

export default PhoneNumberFormatText;